export const API_URL1 = "http://localhost:3001";
export const API_URL2 = "https://mgga-sm-portal-backend.onrender.com";
